export class SharedPagedResponse<T> {
  data?: T[];
  total?: number;
}